import _ from "lodash";
import React from "react";

export default {
  resolveValue: function(obj, id, name) {
    if (obj) return obj;
    if (id === null) return null;
    return { value: id, label: name };
  },
  resolveValueFromList: function(list, value) {
    if (list.length === 0) return;
    return _.find(list, x => {
      return x.value === value;
    });
  },
  resolveStatusColor: function(statusName) {
    switch (statusName) {
      case "Active":
        return "success";
      case "Inactive":
        return "danger";
      case "Out of service but still active":
        return "info";
      default:
        return "secondary";
    }
  },
  resolveCalibrationResults: function(value) {
    switch (value) {
      case true:
        return "success";
      default:
        return "danger";
    }
  },
  inventoryCycleCountInstructions: function () {
    return (
      <div className="detailTextNoSize">
        <div>Select an Area. Use the 'Tab' key to navigate across row. Use the 'Up' & 'Down' arrow keys to navigate list.</div>
        <div>Use 'Esc' to exit date picker. Product/Part and quantity are required fields. To 'Delete' an item enter 0 in the quantity field.</div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/helpers/uiHelper.js